export default {
  labels: {
    selectOne: 'Pilih satu pilihan',
    selectAll: 'Pilih semua yang berkenaan',
    typeResponse: 'Taip jawapan anda dalam kotak teks di bawah.',
    recordResponse: 'Buat rakaman untuk menjawab soalan.',
    enterNumeric: 'Masukkan jawapan berangka dalam medan di bawah.',
    rateResponseScale: 'Nilai jawapan anda pada skala yang disediakan.',
    sliderMinimum: 'Nilai minimum: {value}',
    sliderMaximum: 'Nilai maksimum: {value}',
    selectOneOptionRow: 'Pilih satu pilihan dalam setiap baris.',
    selectAllOptionsRow: 'Pilih semua pilihan yang berkenaan untuk setiap baris.',
    dragAndDropResponse: 'Seret dan lepaskan pilihan untuk menyusunnya mengikut keutamaan.',
    rankOrderDesktopInstruction: 'Seret dan lepas item untuk meranking, atau gunakan butang + untuk menambah item. Gunakan butang anak panah untuk menyusun semula atau butang padam untuk mengalih keluar item.',
    alert: "Amaran",
    error: 'Sila masukkan nombor antara {min} dan {max}.',
    cameras: 'Kamera',
    microphones: 'Mikrofon',
    recording: 'Rakaman',
    noDevicesFound: 'Tiada peranti ditemui',
    camera: 'Kamera',
    microphone: 'Mikrofon',
    stopRecording: 'Hentikan rakaman',
    startRecording: 'Mulakan rakaman',
    disableCamera: 'Nyahlumpuhkan Kamera',
    enableCamera: 'Dayakan Kamera',
    disableMicrophone: 'Nyahlumpuhkan Mikrofon',
    enableMicrophone: 'Dayakan Mikrofon',
    settings: 'Tetapan',
    recordingProgress: 'Kemajuan Rakaman',
    playbackProgress: 'Kemajuan Putar Balik',
    play: 'Mainkan',
    pause: 'Jeda',
    stop: 'Henti',
    record: 'Rakam',
    recordAgain: 'Rakam semula',
    retry: 'Cuba lagi',
    done: 'Selesai',
    minRecordTime: 'Sila rakam jawapan selama {min} saat.',
    enlargeImage: 'Besarkan imej',
    enlargedImage: 'Imej dibesarkan',
    close: 'Tutup',
    zoomIn: 'Zum masuk',
    zoomOut: 'Zum keluar',
    resetZoom: 'Tetapkan semula zum',
    zoomLevel: 'Zum {percentage}%',
    imagePosition: '{current} daripada {total}',
    previousImage: 'Imej sebelumnya',
    nextImage: 'Imej seterusnya',
    imageLoading: 'Memuatkan imej',
    imageLoadFailed: 'Imej tidak dapat dimuatkan',
  },
  noSelection: "Tiada pilihan",
  actions: {
    increase: 'Tingkatkan',
    decrease: 'Kurangkan'
  },
  survey: {
    endOfSurvey: {
      titleTerminated: 'Pratonton Tinjauan Tamat',
      titleCompleted: 'Pratonton Tinjauan Selesai',
      previewModeWarning: 'Halaman ini hanya kelihatan dalam Mod Pratonton dan tidak akan ditunjukkan kepada responden sebenar.',
      reachedEndPoint: 'Tinjauan ini telah mencapai titik akhir.',
      reachedEndPointCompleted: 'Pratonton ini telah mencapai titik akhir.',
      returnToModify: 'Kembali ke soalan sebelumnya untuk mengubah suai jawapan anda dan menguji laluan tinjauan yang berbeza.',
      logic: 'Logik'
    }
  }
}
